import { doc, updateDoc, arrayUnion } from "firebase/firestore";
import { getFirestore } from "./firebase";
import { getUtmParams } from "./whatsappConfig";

const useFirestoreUpdate = (collection, docId) => {
  const db = getFirestore();

  // Function to format the date
  const formatDate = (timestamp) => {
    return new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    }).format(timestamp);
  };

  const updateData = async (data) => {
    const inscriptosRef = doc(db, collection, docId);

    // Format the date before sending
    const formattedDate = formatDate(Date.now());

    const { utm_source, utm_medium, utm_campaign, utm_term } = getUtmParams();

    const newEntry = {
      ...data,
      utm_source,
      utm_medium,
      utm_campaign,
      utm_term: utm_term ?? null,
      createdAt: formattedDate,
    };

    // Update Firestore document
    await updateDoc(inscriptosRef, {
      datos: arrayUnion(newEntry),
    });
  };

  return { updateData };
};

export default useFirestoreUpdate;
